import styled from 'styled-components'
import colors from '../../../_constants/colors'

export const StyledVerificationNote = styled.div`
  border-radius: 5px;
  cursor: ${(props) => (!props.showDocs ? 'pointer' : 'default')};
  display: flex;
  flex-direction: column;
  font-weight: bold;
  justify-items: center;
  min-width: 450px;
  padding: 15px;
  text-align: center;

  @media screen and (min-width: 600px) {
    grid-template-columns: max-content auto;
    justify-items: left;
    text-align: left;
  }

  .icon {
    background-color: white;
    border-radius: 100px;
    padding: 5px;
    padding: 0.25em;
    font-size: 1.5rem;
  }
  .content {
    font-weight: bold;
    margin-bottom: 10px;
    display: flex;
    span {
      margin-left: auto;
      font-size: 16px;
      font-weight: normal;
      color: gray;
    }
  }
  .content:first-child {
    margin-bottom: 3px;
  }
  .message {
    font-size: 0.9em;
    line-height: 1.5em;
    margin-left: 1em;
    font-weight: normal;
    a {
      color: white;
      text-decoration: underline;
      transition: all 0.2s ease-in-out;

      &:hover {
        opacity: 0.75;
      }
    }
  }
  .indicator {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    margin-right: 5px;
    background-color: ${colors.MATERIAL_YELLOW};
    margin-top: 5px;
    &.negative {
      background-color: ${colors.MATERIAL_RED};
    }

    &.positive {
      background-color: ${colors.MATERIAL_GREEN};
    }

    &.neutral {
      background-color: ${colors.NO_VERIFICATION};
    }
  }

  .verification_name {
    font-weight: normal;
  }
  .contact-label {
    margin-left: auto;
    margin-bottom: 6px;
  }
  .created-by-label {
    display: flex;
  }
  .doc-count {
    margin-left: 12px;
    font-size: 12px;
    color: gray;
    background-color: #eee;
    border-radius: 15px;
    padding: 3px;
    border-style: solid;
    border-color: gray;
    border-width: 1px;
  }
`
